export enum UnitOperationLayer {
  PFD = "PFD",
  PnID = "P&ID",
  Reference = "Reference"
}
